import type { HowItWorksParams, HowItWorksReturn, FormattedTextParams } from '../types';
import { formatUSPCardTextContent } from '../helpers';

export default function (params: HowItWorksParams): HowItWorksReturn {
  const { _uid, _editable, component, leftContent, rightContent } = params;

  function processedContent(content: FormattedTextParams[]) {
    return content.map((item) => formatUSPCardTextContent(item));
  }

  return {
    _uid,
    _editable,
    module: 'SHowItWorks',
    component,
    leftContent: processedContent(leftContent),
    rightContent: processedContent(rightContent)
  };
}
